//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Spinner from './Spinner.vue';
import ResultItem from './ResultItem.vue';

export default {
  components: {
    ResultItem,
    Spinner
  },
  computed: {
      ...mapState(['loading', 'showResults' , 'isInitialLoad', 'showError'])
    },
  props: {
    results: Array,
    message: String
  },
  methods: {
    shouldDisplayMessage() {
      return this.showError;
    }
  }
};
